<div class="trends-container">
    <div class="trends-header-div">
        <div class="header-container-div">
            <div class="header-title-div">
                <mat-label class="d-flex">{{'data-analytics.trends' | translate}} &nbsp;
                    <div *ngIf="level==='factory'" [style.display]="level==='factory' ? '' : 'none'"
                        [popover]="trenTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom">
                        <img src="../../../assets/images/icn-info.svg" alt="">
                    </div>
                    <div *ngIf="level==='line'" [style.display]="level==='line' ? '' : 'none'" [popover]="trenTemplate1"
                        triggers="mouseenter:mouseleave" container="body" placement="bottom">
                        <img src="../../../assets/images/icn-info.svg" alt="">
                    </div>
                </mat-label>
            </div>
            <div class="header-toggle-div">
                <div class="toggle-box-div">
                    <div class="toggle-left-div" [class.cost-select]="selectedChartType === 'cost'">
                        <mat-label  (click)="toggleType('cost')"
                            (keydown.enter)="toggleType('cost')"
                            (keydown.space)="toggleType('cost')">{{'data-analytics.cost' | translate}}</mat-label>
                    </div>
                    <div class="toggle-right-div" [class.percent-select]="selectedChartType === 'percentage'">
                        <mat-label  (click)="toggleType('percentage')"
                            (keydown.enter)="toggleType('percentage')"
                            (keydown.space)="toggleType('percentage')">{{'data-analytics.percentage' | translate}}
                        </mat-label>
                    </div>
                </div>

            </div>
            <div class="header-pop-div">
                <mat-icon  (click)="openDialog()" (keydown.enter)="openDialog()"
                    (keydown.space)="openDialog()">fullscreen</mat-icon>
            </div>
        </div>
    </div>
    <div class="trendes-graph" [class.show-div]="selectedChartType === 'cost'">
        <div>
            <div #myContainer class="donut" id="myContainer"></div>
        </div>
    </div>
    <div class="trendes-graph" [class.show-div]="selectedChartType === 'percentage'">
        <div #lineGraphDiv class="donut" id="lineGraphDiv"></div>
    </div>

</div>
<ng-template #trenTemplate>

    <div class="mb-5-data"><strong class="mr-5-data">Cost - </strong> Daily/Monthly trend of Actual Consumption
        Cost and Zero based Waste Target Cost against Target Waste Cost at the Factory level</div>
    <div class="mb-15-data"><strong class="mr-5-data">Percentage - </strong> Daily/Monthly trend of Waste% against
        Target Waste % at the Factory level </div>
    <div class="tooltip-formula-data">
        <div class="tooltip-left-data">
            Waste % =
        </div>
        <div class="tooltip-center-data">
            <div class="tooltip-center-top-data">
                actual consumption cost - zero based waste target cost

            </div>
            <hr class="tooltip-center-middle-data">
            <div class="tooltip-center-bottom-data">
                zero based waste target cost
            </div>

        </div>
        <div class="tooltip-right-data">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #trenTemplate1>

    <div class="mb-5"><strong class="mr-5">Cost - </strong> Daily/Monthly trend of Actual Consumption Cost and Zero
        based Waste
        Target Cost against Target Waste Cost at the Line level</div>
    <div class="mb-15"><strong class="mr-5">Percentage - </strong> Daily/Monthly trend of Waste% against Target Waste %
        at the
        Line level </div>
    <div class="tooltip-formula">
        <div class="tooltip-left">
            Waste % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                actual consumption cost - zero based waste target cost

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                zero based waste target cost
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>